<template>
  <div class="dialog" :class="{ 'active' : showDialog }">
    <div
      class="dialog--content u-extra-medium-padding--bottom c-vehicle-modal"
    >
      <h4 class="u-extra-small-margin--bottom">{{ $t('kolonne.vehicle.title.modal') }}
        
      <div v-show="isLoading">
        <div class="loading-spinner-wrapper">
          <v-page-loading position="absolute" right/>
        </div>
      </div>
    
      </h4>
      
      <h5 class="u-color--primary u-extra-small-margin--bottom">{{ $t('kolonne.title') }} {{ current_kolonne_number }}</h5>
      
      <p v-if="current_kolonne_id == ''" class="is-error">
        {{ $t('kolonne.error.nokolonne') }}
      </p>
      
      <div v-else>
        
          <form @submit="submitForm">
            
            <div class="grid-x grid-margin-x align-bottom">
              
              <div class="cell shrink">
                
                <label for="vehicle"> {{ $t('kolonne.vehicle.select.label') }} </label>
                <select name="vehicle" id="vehicle" class="form-control form-control--select">
                   <option v-for="(option, index) in this.vehicleOptions" :key="index" :value="option.value">
                     {{ option.value }}
                   </option>
                </select>
                
              </div>
              
              <div class="cell auto">
                  <label for="licensenumber">{{ $t('kolonne.vehicle.number') }}</label>
                    <input required type="text" name="licensenumber" id="licensenumber" class="form-control--small">
              </div>
              
              <div class="cell shrink">
                  <button :title="$t('create_new')" class="c-vehicle__button--add"><svg class="u-icon--add" role="presentation">
                      <use
                        xlink:href="/dist/sprite.svg#icon-add"
                        href="/dist/sprite.svg#icon-add"
                      />
                    </svg>
                  </button>
              </div>
              
            </div>
            
          </form>
        
          <p v-if="this.vehicles.length === 0" class="u-color--alert text-center h6">
          {{ $t('kolonne.message.novehicles') }}
          </p>
          
          <template v-if="this.vehicles.length >= 1">
            <h6 class="u-color--primary u-extra-small-margin--bottom u-extra-small-margin--top">{{ $t('kolonne.vehicle.title.addedvehicles') }}</h6>
              <ul class="c-vehicle-modal__vehicle-list">
                <li v-for="(item, index) in this.vehicles" :key="index">
                  {{item.type}}: {{item.number}} 
                  
                  <button :title="$t('delete')" class="c-vehicle__button--delete" @click.prevent="deleteVehicle(index)">
                    <svg class="u-icon--delete" role="presentation">
                      <use
                        xlink:href="/dist/sprite.svg#icon-delete"
                        href="/dist/sprite.svg#icon-delete"
                      />
                    </svg>
                  </button>
                </li>
              </ul>
          </template>  
               
      </div>
      
      <button class="close-button" @click.prevent="onCloseDialog">
          <span aria-hidden="true">&times;</span>
      </button>
         
    </div>
  </div>
</template>

<script>

import PageLoading from "./../partials/PageLoading";

export default {
  name: "KolonneVehiclesModal",

  components: {
    vPageLoading: PageLoading
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    current_vehicles: {
      type: Array | null,
      default: null
    },
    current_kolonne_id: {
      type: Number | String,
      default: ''
    },
    current_kolonne_number: {
      type: Number | String,
      default: ''
    }
  },
  model: {
    prop: "showDialog",
    event: "showchange"
  },
  data() {
    return {
      loading: false,
      licensenumber: '',
      vehicle: '',
      vehicles: [],
      hasError: false,
      errorMessage: null,
      vehicleOptions: [
        {'key':'Sprinter','value':'Sprinter'},
        {'key':'LKW-1','value':'LKW-1'},
        {'key':'LKW-2','value':'LKW-2'},
        {'key':'LKW-3','value':'LKW-3'},
        {'key':'Anhänger-1','value':'Anhänger-1'},
        {'key':'Anhänger-2','value':'Anhänger-2'},
        {'key':'Anhänger-3','value':'Anhänger-3'},
      ]
    };
  },
  
  computed: {
    isLoading: function() {
      return this.loading;
    },
    showDialog: {
      get: function() {
        if (this.isVisible) {
          this.onOpenDialog();
          this.getVehicles();
        }
        return this.isVisible;
      },
      set: function(value) {
        this.$emit("showchange", value);
      }
    }
  },
  
  methods: {
    
    /** Modal Settings */
    onOpenDialog: function() {
      this.showDialog = true;
    },

    onCloseDialog: function() {
      this.showDialog = false;
    },
    
    /** Form Settings */
    submitForm: function(e) {
      e.preventDefault();
      this.licensenumber = licensenumber.value.trim();
      this.vehicle = vehicle.value;
      
      this.addVehicle();
    },
    
    /** API Settings */
    addVehicle: function() {
      this.vehicles.push({type: this.vehicle, number: this.licensenumber});
      this.updateVehicles();
    },
    
    deleteVehicle: function(item) {
      this.vehicles.splice(item, 1);
      this.updateVehicles();
    },
    
    getVehicles: function() {
      window.app.$helpers.logger(
          "Getting Vehicles for Kolonne " + this.current_kolonne_number + " ..."
       );
      
      let promise = this.$api.clearParams().get("kolonne-settings/" + this.current_kolonne_id);
      
      promise
      .then(response => {
        this.vehicles = response.data.data.vehicles;
      })
      .catch(error => {
         window.app.$helpers.logger(error);
      });
    },
    
    broadcastChanges: function() {
        window.app.$helpers.logger(
          "Emitting vehicles ..."
       );
       this.$emit("vehicles", {
         vehicles : this.vehicles,
         kolonne_id: this.current_kolonne_id  
       });
    },
    
    updateVehicles: function() {
       this.loading = true;
       
       const body = {
         vehicles: this.vehicles
       }
       
       window.app.$helpers.logger(
            "Updating Vehicles body:", body
       );
       
       let promise = this.$api.clearParams().put('kolonne-settings/' + this.current_kolonne_id + '/', body);
       
       promise
       .then(response => {
         
         if (response.data.data) {
            window.app.$helpers.logger(
                "Updating Vehicles a success..."
            );
            this.broadcastChanges();
            this.getVehicles();
         }
           
       })
        .catch(error => {
         window.app.$helpers.logger(error);
      })
      .finally(() => {
        this.loading = false;
      });
    }
  }
};
</script>